@if (inputGroupAppendButtonsTmpl == undefined) {
  <div [class]="toggleBtnVisible ? 'position-relative' : ''">
    <ng-content></ng-content>
    <ng-container [ngTemplateOutlet]="toggleBtnTmpl"></ng-container>
  </div>
}

<ng-template #inputGroupAppendTmpl>
  <ng-container [ngTemplateOutlet]="toggleBtnTmpl"></ng-container>
  @if (inputGroupAppendButtonsTmpl) {
    <ng-container [ngTemplateOutlet]="inputGroupAppendButtonsTmpl"></ng-container>
  }
</ng-template>

<ng-template #toggleBtnTmpl>
  <button
    id="password-to-text-toggle-button"
    #toggleBtn
    [class]="toggleButtonClass"
    [hidden]="toggleBtnVisible === false"
    (click)="toggle()"
    type="button"
  >
    <!-- {{ (plainText ? 'general.hide' : 'general.show') | translate }} -->
    <i class="far fa-fw" [class]="plainText ? 'fa-eye-slash' : 'fa-eye'"></i>
  </button>
</ng-template>
